import _native from '@zz-common/native-adapter';

var asyncAdapter = function asyncAdapter(method, params, callback) {
  return _native.wrap(method)(params, callback);
};

export var nativeLogin = function nativeLogin(params, callback) {
  asyncAdapter('login', params, callback);
};
export var nativeEnterUnifiedUrl = function nativeEnterUnifiedUrl(params, callback) {
  asyncAdapter('enterUnifiedUrl', params, callback);
};
export var nativeSkipToUrl = function nativeSkipToUrl(params) {
  asyncAdapter('skipToUrl', params);
};
export var nativeGetUserInfo = function nativeGetUserInfo(params, callback) {
  asyncAdapter('getUserInfo', params, callback);
};
export var nativeIsLogin = function nativeIsLogin() {
  return _native.isLogin();
};